import { Theme } from '@mui/material';

/** Shared surface for every card and panel of the performance tab. */
export const cardSurface = {
  border: '1px solid',
  borderColor: 'grey.100',
  boxShadow: (theme: Theme) => theme.palette.tokens.shadows.card,
};
